import { render, staticRenderFns } from "./DerivativePricingComponent.vue?vue&type=template&id=7845a0dc"
import script from "./DerivativePricingComponent.vue?vue&type=script&lang=ts"
export * from "./DerivativePricingComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports